import { atom, useAtom, useSetAtom } from 'jotai';

export const countSideLayoutOpen = atom(0);
export const isFocusedAtom = atom(false);

export { useAtom, useSetAtom };
